var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaigeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37598 0.00732422V4.38407H14.6001V14.6087H18.9774V0.00732422H4.37598Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.9854H14.6014V14.6082H4.37728V4.38403H0V18.9854Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaigeLogo);
export default __webpack_public_path__ + "static/media/staige-logo.e8b52447e91c52ce6baac21fd2848e59.svg";
export { ForwardRef as ReactComponent };